module.exports = __webpack_public_path__ + "static/img/quesheng.7eba812.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/list/quesheng.png
// module id = mo8p
// module chunks = 1